<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h2 id="dashboard-header">
            Absolventi
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="graduates"
            item-value="id"
            class="elevation-1"
          >
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn color="primary" @click="exportGraduates">
            Export to XLSX
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Graduates",
  data() {
    return {
      headers: [
        { title: "First Name", key: "firstName" },
        { title: "Last Name", key: "lastName" },
        { title: "Graduation Year", key: "graduationYear" },
        { title: "Email", key: "email" },
        { title: "Faculties", key: "formattedFaculties" },
        { title: "Country", key: "country" },
        { title: "Language", key: "locale" },
        { title: "Registered", key: "formattedCreated" },
      ],
    };
  },

  created() {
    this.fetchAllGraduates();

  },

  computed: {
    ...mapGetters("Graduates", ["getGraduates"]),

    graduates() {
      return this.getGraduates.map((g) => ({
        ...g,
        formattedFaculties: g.faculties
          ? g.faculties.map((f) => f.key).join(", ")
          : "",
        formattedCreated: g.created
          ? new Date(g.created).toLocaleDateString("cs-CZ", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "",
      }));
    },
  },
  methods: {
    ...mapActions("Graduates", ["exportGraduates", "fetchAllGraduates"]),
  },
};
</script>

<style scoped>
</style>
